import React from 'react';
import { Container } from '../ui/Container';
import { Button } from '../ui/Button';
import { useIsMobile } from '../../Hooks/useIsMobile';
import { getImagePath } from '../../Utils/Utilities';
import ConditionalDiv from '../Common/ConditionalDiv';

const PDFFeatureSection = ({
    title,
    slogan,
    buttonText,
    pdfUrl,
    thumbnailUrl,
    className,
    id,
    thumbnailPosition = 'right',
    titleWeb,
    sloganWeb,
    buttonTextWeb,
    onButtonClick,
    onButtonClickWeb,
    logo
}) => {
    const isMobile = useIsMobile();

    const handleOpenPDF = () => {
        window.open(pdfUrl, '_blank');
    };

    const handleDesktopButtonClick = () => {
        if (onButtonClickWeb) {
            onButtonClickWeb();
        } else {
            handleOpenPDF();
        }
    };

    const handleMobileButtonClick = () => {
        if (onButtonClick) {
            onButtonClick();
        } else {
            handleOpenPDF();
        }
    };
    // Mobile view - always stacked
    if (isMobile) {
        return (
            <section id={id} className={`py-4 ${className || ''}`}>
                <Container>
                    <div className="max-w-4xl mx-auto">
                        {/* Logo Section */}
                        {logo && (
                            <div className="flex flex-col items-center mb-4 relative">
                                <img
                                    src={logo}
                                    alt="Logo"
                                    className={`${logo.includes('Biziverse.png') ? 'h-[70px]' : 'h-[120px]'} w-auto object-contain`}
                                />
                                {!logo.includes('Biziverse.png') && (
                                    <div className="flex flex-col items-center absolute" style={{ top: '90px', left: '135px' }}>
                                        <span className="text-sm text-primary font-bold mb-0.5">by</span>
                                        <img
                                            src={getImagePath("/Images/Biziverse.png")}
                                            alt="Biziverse"
                                            className="h-[26px] w-auto object-contain"
                                        />
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Header */}
                        <div className="text-center mb-4">
                            {typeof (titleWeb || title) === 'string' ? (
                                <h3 className="text-[30px] font-bold secttl  px-6 ">
                                    {title}
                                </h3>
                            ) : (
                                <div className="px-6 pt-8">
                                    {<h3 className="text-[30px] font-bold secttl px-6 ">{title}</h3>}
                                </div>
                            )}
                        </div>


                        {/* Thumbnail Preview Container */}
                        <div className="mb-2 px-4 relative group cursor-pointer" onClick={handleOpenPDF}>
                            <img
                                src={thumbnailUrl}
                                alt={`${title} Preview`}
                                className="w-[100%] md:w-[85%] max-w-3xl mx-auto h-auto rounded-[5px] border-[5px] border-[#e5e5e5] shadow-[0_5px_10px_rgba(0,0,0,0.1)] cursor-pointer transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_7px_14px_rgba(0,0,0,0.15)]"
                            />

                            {/* Centered YouTube Icon Overlay */}
                            {/* <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                <img
                                    src={getImagePath("/Images/youtube.png")}
                                    alt="Play"
                                    className="w-32 h-auto object-contain drop-shadow-2xl transform transition-transform duration-300 group-hover:scale-110"
                                />
                            </div> */}
                        </div>

                        {/* Action Button */}
                        {buttonText && <div className="mt-8 flex justify-center">
                            <Button
                                onClick={handleMobileButtonClick}
                                size="default"
                                variant="primaryDarkBlue"
                            >
                                {buttonText}
                            </Button>
                        </div>}
                    </div>
                </Container>
            </section >
        );
    }

    // Desktop view - side by side layout
    return (
        <section id={id} className={`py-12 ${className || ''}>`}>
            <Container variant={isMobile ? "default" : "wide"}>
                <div className="flex items-center gap-[10rem] justify-center" style={{ padding: '0 5%' }}>
                    {/* Left Column */}
                    <div className={`${thumbnailPosition === 'right' ? 'w-[35%]' : 'w-[40%]'} ${thumbnailPosition === 'left' ? 'order-2' : 'order-1'}`}>
                        <h1 className="text-[40px] font-bold text-primary mb-0" style={{ textShadow: '2px 2px 3px rgb(0 0 0 / 10%)' }}>
                            {titleWeb || title}
                        </h1>

                        <div className="mt-5">
                            {sloganWeb ? (
                                <div className="block text-xl font-normal text-text-primary mb-4 leading-relaxed space-y-4">
                                    {sloganWeb}
                                </div>
                            ) : (
                                <p className="block text-xl font-medium text-text-primary mb-4 leading-[5vh]">
                                    {slogan}
                                </p>
                            )}
                        </div>

                        <div className="mt-5">
                            <Button
                                onClick={handleDesktopButtonClick}
                            >
                                {buttonTextWeb || buttonText}
                            </Button>
                        </div>
                    </div>

                    {/* Right Column - Video/Thumbnail */}
                    <div className={`flex-shrink-0 ${thumbnailPosition === 'left' ? 'order-1' : 'order-2'} px-4 relative group cursor-pointer`} style={{ width: '600px' }} onClick={handleOpenPDF}>
                        <img
                            src={thumbnailUrl}
                            alt={`${title} Preview`}
                            className="w-[100%] md:w-[85%] max-w-3xl mx-auto h-auto rounded-[5px] border-[5px] border-[#e5e5e5] shadow-[0_5px_10px_rgba(0,0,0,0.1)] cursor-pointer transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_7px_14px_rgba(0,0,0,0.15)]"
                        />

                        {/* Centered YouTube Icon Overlay */}
                        {/* <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                            <img
                                src={getImagePath("/Images/youtube.png")}
                                alt="Play"
                                className="w-72 h-auto object-contain drop-shadow-2xl transform transition-transform duration-300 group-hover:scale-110"
                            />
                        </div> */}
                    </div>
                </div>
            </Container>
        </section>
    );
};
export default PDFFeatureSection;